import React, { useEffect, useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../api";
import { CGU_TEXT, CGV_TEXT, PRIVACY_TEXT, MENTIONS_TEXT, LEGAL_VERSION } from "../legal/texts";

const DEFAULTS = {
  cgu: { title: "Conditions Générales d'Utilisation (CGU)", body: CGU_TEXT },
  cgv: { title: "Conditions Générales de Vente (CGV)", body: CGV_TEXT },
  privacy: { title: "Politique de confidentialité", body: PRIVACY_TEXT },
  mentions: { title: "Mentions légales", body: MENTIONS_TEXT },
};

export default function LegalPage() {
  const { doc } = useParams();
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!DEFAULTS[doc]) { setLoaded(true); return; }
    setLoaded(false);
    api.get(`/legal/${doc}`).then(({ data }) => {
      if (data && data.body && data.body.trim().length > 0) {
        setContent({ title: data.title || DEFAULTS[doc].title, body: data.body, version: data.version || LEGAL_VERSION, updated_at: data.updated_at });
      } else {
        setContent({ ...DEFAULTS[doc], version: LEGAL_VERSION, updated_at: null });
      }
    }).catch(() => {
      setContent({ ...DEFAULTS[doc], version: LEGAL_VERSION, updated_at: null });
    }).finally(() => setLoaded(true));
  }, [doc]);

  if (!DEFAULTS[doc]) return <Navigate to="/legal/cgu" replace />;
  if (!loaded || !content) return <div className="p-12 text-center text-slate-500">Chargement…</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid={`legal-${doc}`}>
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-sky-700 mb-6 hover:underline">
        <ArrowLeft className="w-4 h-4" />Retour à l'accueil
      </Link>
      <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>{content.title}</h1>
      <p className="text-xs text-slate-500 mb-6">
        Version {content.version || LEGAL_VERSION}
        {content.updated_at && <span> • mis à jour le {new Date(content.updated_at).toLocaleDateString("fr-FR")}</span>}
      </p>
      <div className="card-soft p-8">
        <pre className="whitespace-pre-wrap font-sans text-sm text-slate-700 leading-relaxed">{content.body}</pre>
      </div>
      <div className="mt-6 flex flex-wrap gap-3 text-sm">
        <Link to="/legal/cgu" className="text-sky-700 hover:underline">CGU</Link>
        <Link to="/legal/cgv" className="text-sky-700 hover:underline">CGV</Link>
        <Link to="/legal/privacy" className="text-sky-700 hover:underline">Confidentialité</Link>
        <Link to="/legal/mentions" className="text-sky-700 hover:underline">Mentions légales</Link>
      </div>
    </div>
  );
}
